import { Component, ChangeDetectionStrategy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToasterService } from "@shared/services/toaster.service";
import { AdminSlackApiService } from "@shared/services/admin/admin-slack-api.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { LogService } from "@shared/services/log.service";

export interface ManageSelfhostedSlackBridgeDialogContext {
    provisionUrl: string;
    bridgeId: number;
    isAdding: boolean;
}

@Component({
    templateUrl: "./manage-selfhosted.component.html",
    styleUrls: ["./manage-selfhosted.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, TranslatePipe]
})
export class AdminSlackBridgeManageSelfhostedComponent {

    public isSaving = false;
    public provisionUrl: string;
    public bridgeId: number;
    public isAdding = true;

    constructor(
        public modal: NgbActiveModal,
        private readonly slackApi: AdminSlackApiService,
        private readonly toaster: ToasterService,
        public translate: TranslateService,
        private readonly logService: LogService,
    ) {
        this.translate = translate;
    }

    public add() {
        this.isSaving = true;
        if (this.isAdding) {
            this.slackApi.newSelfhosted(this.provisionUrl).then(() => {
                this.translate.get('Slack bridge added').subscribe((res: string) => {
                    this.toaster.pop("success", res);
                });
                this.modal.close();
            }).catch(err => {
                this.logService.error(err);
                this.isSaving = false;
                this.translate.get('Failed to create Slack bridge').subscribe((res: string) => {
                    this.toaster.pop("error", res);
                });
            });
        } else {
            this.slackApi.updateSelfhosted(this.bridgeId, this.provisionUrl).then(() => {
                this.translate.get('Slack bridge updated').subscribe((res: string) => this.toaster.pop("success", res));
                this.modal.close();
            }).catch(err => {
                this.logService.error(err);
                this.isSaving = false;
                this.translate.get('Failed to update Slack bridge').subscribe((res: string) => {
                    this.toaster.pop("error", res);
                });
            });
        }
    }
}
